import { FC } from "react";
import classNames from "classnames";

import styles from "./index.less";

import { PricingPlanVersionEnum } from "../../types";

interface PlanTagProps {
  version: PricingPlanVersionEnum;
}

/**
 * 订阅计划的标签
 * @returns
 */
const PlanTag: FC<PlanTagProps> = ({ version }) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles["container-basic"]]: version === PricingPlanVersionEnum.BASIC,
        [styles["container-plus"]]: version === PricingPlanVersionEnum.PLUS,
        [styles["container-pro"]]: version === PricingPlanVersionEnum.PRO,
        [styles["container-ultra"]]: version === PricingPlanVersionEnum.ULTRA,
      })}
    >
      <div className={styles.text}>
        {version === PricingPlanVersionEnum.BASIC && "Basic"}
        {version === PricingPlanVersionEnum.PLUS && "Plus"}
        {version === PricingPlanVersionEnum.PRO && "Pro"}
        {version === PricingPlanVersionEnum.ULTRA && "Ultra"}
      </div>
    </div>
  );
};

export default PlanTag;
